export const confirmModals = state => state.modals;
